/**
 * 组件包含两个 api
 * config: 覆盖默认配置, 可覆盖属性包括 appid platform domain rate
 *     appid: 开发者注册的产品id, 这里同一业务测速和返回码共用一个
 *     platform: 用来标识，客户端的平台，用于区分pc、h5页面, 该组件中会有默认实现
 *     domain: cgi所属域名, 考核按业务划分 所以同业务的domain值需设置一致
 *     rate: 采样频率，为n表示每n次请求上报一次
 *     apn: 用户网络类型(2g,3g,4g,wifi,unknow)，不上报根据ip库识别，为全局配置
 * report: 上报接口，上报字段有url ec cost uin opt
 *     url: url的pathname，格式前不能带域名或其他非url字段
 *     ec: 返回码直接上报 另外ec=0时type为1-表示正常，状态码为4xx-5xx时为2-表示失败，状态码为其他则type为3-表示逻辑失败
 *     cost: cgi耗时
 *     uin: 用户uin
 *     opt: 扩展参数，如apn(可覆盖全局apn) delay(上报延迟 默认延迟1s上报 dealy=0时立即上报)
 * 相关文档指引：http://tapd.oa.com/mhb/markdown_wikis/#1010084921005723541
 * @author moonye
 */
var reportUrl;
var reportCGI = '//report.huatuo.qq.com/code.cgi';
var taskList = [];
var isServer = typeof document === 'undefined';
/**
 * cgi侧其实会补齐platform字段，但防止cgi侧只针对已有域名做platform补齐，这里组件统一做
 * @memberof module:retcode
 * @return {string} [返回平台类型ios, android或pc]
 */

function getPlatform() {
  if (isServer) {
    return '';
  }

  var ua = navigator.userAgent.toLowerCase();

  if (/\(i[^;]+;( U;)? CPU.+Mac OS X/i.test(ua)) {
    return 'ios';
  }

  if (ua.indexOf('android') > -1 || ua.indexOf('adr') > -1) {
    return 'android';
  }

  return 'pc';
}
/* 默认配置 */


var CONFIG = {
  appid: 20466,
  platform: getPlatform(),
  domain: 'fudao.qq.com',
  rate: 1,
  apn: '' // 用户网络类型(2g,3g,4g,wifi,unknow)，不上报根据ip库识别

}; // 返回码请求默认延迟上报

var delay = 2000;
var timer = null;

function doReport(list) {
  var protocol = window.location.protocol;
  var reportUrlPrefix = "".concat(protocol).concat(reportCGI);
  reportUrl = reportUrl || reportUrlPrefix;
  list = list || taskList; // 每次最多上报10条  避免超出 get请求长度限制

  var len = list.length;

  if (len > 10) {
    len = 10;
  } // 每次最多合并上报10条数据


  var tempArray = list.splice(0, len);

  if (tempArray.length === 0) {
    return;
  } // uin和apn来源单次请求数据


  var src = "".concat(reportUrl, "&uin=").concat(tempArray[0].uin, "&apn=").concat(tempArray[0].apn || CONFIG.apn); // 处理 cgi type code 和 time

  src += '&key=cgi,type,code,time';
  var attrArray = ['cgi', 'type', 'code', 'time'];

  for (var j = 0; j < attrArray.length; j++) {
    for (var i = 0; i < tempArray.length; i++) {
      var data = tempArray[i];
      src += "&".concat(i + 1, "_").concat(j + 1, "=").concat(data[attrArray[j]]);
    }
  }

  src += "&ignoreRandom=".concat(Math.random()); // const img = new Image();
  // img.src = src;
}

function combineUrl() {
  var protocol = window.location.protocol;
  var reportUrlPrefix = "".concat(protocol).concat(reportCGI);
  var d = [];
  var upConfig = ['domain', 'appid', 'platform'];

  for (var k = 0; k < upConfig.length; k++) {
    var key = upConfig[k];
    d.push("".concat(key, "=").concat(CONFIG[key]));
  }

  reportUrl = "".concat(reportUrlPrefix, "?").concat(d.join('&'));
}
/**
 * 设置全局配置
 * @param  {object} c [配置上报属性]
 * @return {undifined}   [无返回值]
 * @memberof module:retcode
 */


function config(c) {
  // 组件补齐platform字段
  CONFIG.platform = getPlatform();
  CONFIG = Object.assign({}, CONFIG, c); // 全局参数确定了 可以确定url前缀了

  combineUrl();
}
/**
 * 特殊情况下需要立即上报 比如delay设置为0 比如apn与全局参数apn不一样
 * @param  {object} data [立即上报数据]
 * @return {boolean}      [如果是立即上报则返回true，否则返回false]
 */


function reportImmediate(data) {
  var _delay = data.delay;

  if (_delay === 0 || data.apn !== CONFIG.apn) {
    doReport([data]);
    return true;
  }

  return false;
}
/**
 *
 * @param  {string} url  [url的pathname，格式前不能带域名或其他非url字段]
 * @param  {number} ec   [返回码直接上报 另外ec=0时type为1-表示正常，状态码为4xx-5xx时为2-表示失败，状态码为其他则type为3-表示逻辑失败]
 * @param  {number} cost [请求耗时]
 * @param  {string} uin  [用户uin]
 * @param  {object} opt  [扩展参数配置]
 * @return {undefined}      [无返回值]
 * @memberof module:retcode
 */


function report(url, ec, cost, uin, opt) {
  if (process.env.NODE_ENV !== 'production') {
    return;
  }

  if (isServer) {
    return;
  } // url ec cost opt


  if (timer) {
    clearTimeout(timer);
  }

  var type;

  if (ec === 0) {
    type = 1;
  } else if (/^[4|5][0-9]{2}$/.test(String(ec))) {
    type = 2;
  } else {
    type = 3;
  }

  var data = Object.assign({
    cgi: encodeURIComponent(url),
    code: ec,
    time: cost,
    uin: uin,
    type: type
  }, CONFIG, opt); // 是否立即上报

  if (reportImmediate(data)) {
    return;
  }

  taskList.push(data);
  timer = setTimeout(doReport, delay);
} // 初始化配置， 外部组件在参数不变情况下可直接使用report上报


if (!isServer) {
  config();
}

var retcode = {
  config: config,
  report: report
}; // eslint-disable-next-line

export { retcode };